import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule } from '@angular/forms';
import { OwlModule } from 'ngx-owl-carousel';
import { TreeModule } from 'angular-tree-component';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatFormFieldModule, MatInputModule, MatIconModule, MatRadioModule, MatPaginatorModule, MatSelectModule } from '@angular/material';
import { StorageServiceModule } from 'angular-webstorage-service';
// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


import { AppComponent } from './app.component';

/* Sections */
import { SectionManuscriptsComponent } from './components/sections/section-manuscripts/section-manuscripts.component';
import { SectionBibliographyComponent } from './components/sections/section-bibliography/section-bibliography.component';
import { SectionCriticalEditionComponent } from './components/sections/section-critical-edition/section-critical-edition.component';
import { SectionProjectComponent } from './components/sections/section-project/section-project.component';
import { SectionSearchComponent } from './components/sections/section-search/section-search.component';
import { SectionDownloadsComponent } from './components/sections/section-downloads/section-downloads.component';

/* Pages */
import { PageHomeComponent } from './components/pages/page-home/page-home.component';
import { PageLoginComponent } from './components/pages/page-login/page-login.component';
import { PageNotFoundComponent } from './components/pages/page-not-found/page-not-found.component';
import { AppRoutingModule } from './app-routing.module';
// import { PageManuscriptsComponent } from './components/pages/page-manuscripts/page-manuscripts.component';
import { PageManuscriptIntroComponent } from './components/pages/page-manuscript-intro/page-manuscript-intro.component';
import { PageManuscriptListComponent } from './components/pages/page-manuscript-list/page-manuscript-list.component';
import { PageManuscriptCardComponent } from './components/pages/page-manuscript-card/page-manuscript-card.component';
import { PageManuscriptTimelineComponent } from './components/pages/page-manuscript-timeline/page-manuscript-timeline.component';
import { PageBiblioListComponent } from './components/pages/page-biblio-list/page-biblio-list.component';
import { PageBiblioCardComponent } from './components/pages/page-biblio-card/page-biblio-card.component';
import { PageCriticalEditionViewComponent } from './components/pages/page-critical-edition-view/page-critical-edition-view.component';
import { PageCriticalEditionSamplesComponent } from './components/pages/page-critical-edition-samples/page-critical-edition-samples.component';
import { PageCriticalEditionStructureIntroComponent } from './components/pages/page-critical-edition-structure-intro/page-critical-edition-structure-intro.component';
import { PageCriticalEditionIntroComponent } from './components/pages/page-critical-edition-intro/page-critical-edition-intro.component';
import { PageCriticalEditionIntroWorkComponent } from './components/pages/page-critical-edition-intro-work/page-critical-edition-intro-work.component';
import { PageCriticalEditionTeiSchemaComponent } from './components/pages/page-critical-edition-tei-schema/page-critical-edition-tei-schema.component';
import { PageCriticalEditionTeiDownloadsComponent } from './components/pages/page-critical-edition-tei-downloads/page-critical-edition-tei-downloads.component';
import { PageInfoComponent } from './components/pages/page-info/page-info.component';
import { PageContactComponent } from './components/pages/page-contact/page-contact.component';
import { PageStemmaComponent } from './components/pages/page-stemma/page-stemma.component';
import { PageSearchInfoComponent } from './components/pages/page-search-info/page-search-info.component';
import { PageSearchImagesComponent } from './components/pages/page-search-images/page-search-images.component';
import { PageSearchEditionComponent } from './components/pages/page-search-edition/page-search-edition.component';
import { PageTermsOfUseComponent } from './components/pages/page-terms-of-use/page-terms-of-use.component';
import { PageProjectIntroComponent } from './components/pages/page-project-intro/page-project-intro.component';
import { PageDownloadsMssComponent } from './components/pages/page-downloads-mss/page-downloads-mss.component';
import { PageDownloadsIndirectComponent } from './components/pages/page-downloads-indirect/page-downloads-indirect.component';
import { PageDownloadsIntroComponent } from './components/pages/page-downloads-intro/page-downloads-intro.component';
import { PageDownloadsCataloguesComponent } from './components/pages/page-downloads-catalogues/page-downloads-catalogues.component';

/* User interface */
import { HeaderComponent } from './components/ui/header/header.component';
import { FooterComponent } from './components/ui/footer/footer.component';
import { NavbarComponent } from './components/ui/navbar/navbar.component';
import { BreadcrumbsComponent } from './components/ui/breadcrumbs/breadcrumbs.component';
import { HomeSliderComponent } from './components/ui/home-slider/home-slider.component';
import { TimelineComponent } from './components/ui/timeline/timeline.component';
import { HomeMapComponent } from './components/ui/home-map/home-map.component';
import { HomeCarouselComponent } from './components/ui/home-carousel/home-carousel.component';
import { HomeTimechartComponent } from './components/ui/home-timechart/home-timechart.component';
import { HomeMssDistributionComponent } from './components/ui/home-mss-distribution/home-mss-distribution.component';
import { MssFiltersComponent } from './components/ui/mss-filters/mss-filters.component';
import { MssFiltersTagsComponent } from './components/ui/mss-filters-tags/mss-filters-tags.component';
import { MssListComponent } from './components/ui/mss-list/mss-list.component';
import { MsImageGalleryComponent } from './components/ui/ms-image-gallery/ms-image-gallery.component';
import { MsDetailsComponent } from './components/ui/ms-details/ms-details.component';
import { MsDetailsDescriptionComponent } from './components/ui/ms-details-description/ms-details-description.component';
import { MsDetailsHistoryComponent } from './components/ui/ms-details-history/ms-details-history.component';
import { MsDetailsContentComponent } from './components/ui/ms-details-content/ms-details-content.component';
import { MsDetailsRemarkpassComponent } from './components/ui/ms-details-remarkpass/ms-details-remarkpass.component';
import { MsDetailsTransmissionsComponent } from './components/ui/ms-details-transmissions/ms-details-transmissions.component';
import { MsDetailsOtherInfoComponent } from './components/ui/ms-details-other-info/ms-details-other-info.component';
import { BiblioSearchFormComponent } from './components/ui/biblio-search-form/biblio-search-form.component';
import { BiblioListComponent } from './components/ui/biblio-list/biblio-list.component';
import { BiblioCardComponent } from './components/ui/biblio-card/biblio-card.component';
import { IIPSrvImageComponent } from './components/ui/iipsrv-image/iipsrv-image.component';
import { CeViewerComponent } from './components/ui/ce-viewer/ce-viewer.component';
import { CeApparatusComponent } from './components/ui/ce-apparatus/ce-apparatus.component';
import { SearchImagesFiltersComponent } from './components/ui/search-images-filters/search-images-filters.component';
import { SearchImagesListComponent } from './components/ui/search-images-list/search-images-list.component';
import { SearchEditionFormComponent } from './components/ui/search-edition-form/search-edition-form.component';
import { SearchEditionResultsComponent } from './components/ui/search-edition-results/search-edition-results.component';
import { ContentUpdateInfoComponent } from './components/ui/content-update-info/content-update-info.component';
import { PageContentsComponent } from './components/ui/page-contents/page-contents.component';

/* Services */
import { AppContentsService } from './services/app-contents.service';
import { VocsService } from './services/vocs.service';
import { ManuscriptsService } from './services/manuscripts.service';
import { CeTooltipService } from './services/ce-tooltip.service';
import { CeReferenceService } from './services/ce-reference.service';
import { CriticalEditionService } from './services/critical-edition.service';
import { SearchEditionService } from './services/search-edition.service';
import { AppStorageService } from './services/app-storage.service';

/* Pipes */
import { FilterVocByParentPipe } from './pipes/filter-voc-by-parent.pipe';
import { GetMsTitlePipe } from './pipes/get-ms-title.pipe';
import { GetMsDatePipe } from './pipes/get-ms-date.pipe';
import { ImageGetNamePipe } from './pipes/image-get-name.pipe';
import { ImageGetFolderPipe } from './pipes/image-get-folder.pipe';
import { VocTermByIdPipe } from './pipes/voc-term-by-id.pipe';
import { InArrayPipe } from './pipes/in-array.pipe';
import { RemoveBracketsContentPipe } from './pipes/remove-brackets-content.pipe';
import { FilterRespsByTypePipe } from './pipes/filter-resps-by-type.pipe';
import { StripHtmlPipe } from './pipes/strip-html.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { SearchSectionLabelPipe } from './pipes/search-section-label.pipe';
import { GetCeStructureTitlePipe } from './pipes/get-ce-structure-title.pipe';

@NgModule({
    declarations: [
        AppComponent,
        SectionManuscriptsComponent,
        SectionBibliographyComponent,
        SectionCriticalEditionComponent,
        SectionProjectComponent,
        SectionSearchComponent,
        SectionDownloadsComponent,
        PageHomeComponent,
        PageLoginComponent,
        PageNotFoundComponent,
//      PageManuscriptsComponent,
        PageManuscriptIntroComponent,
        PageManuscriptListComponent,
        PageManuscriptCardComponent,
        PageManuscriptTimelineComponent,
        HeaderComponent,
        FooterComponent,
        NavbarComponent,
        BreadcrumbsComponent,
        PageBiblioListComponent,
        PageBiblioCardComponent,
        PageCriticalEditionViewComponent,
        PageCriticalEditionSamplesComponent,
        PageCriticalEditionIntroComponent,
        PageCriticalEditionIntroWorkComponent,
        PageCriticalEditionStructureIntroComponent,
        PageCriticalEditionTeiSchemaComponent,
        PageCriticalEditionTeiDownloadsComponent,
        PageInfoComponent,
        PageContactComponent,
        PageStemmaComponent,
        PageSearchInfoComponent,
        PageSearchImagesComponent,
        PageDownloadsMssComponent,
        PageDownloadsIndirectComponent,
        PageDownloadsIntroComponent,
        PageDownloadsCataloguesComponent,
        PageSearchEditionComponent,
        PageTermsOfUseComponent,
        PageProjectIntroComponent,
        HomeSliderComponent,
        TimelineComponent,
        HomeMapComponent,
        HomeCarouselComponent,
        HomeTimechartComponent,
        HomeMssDistributionComponent,
        MssFiltersComponent,
        MssListComponent,
        MssFiltersTagsComponent,
        MsImageGalleryComponent,
        MsDetailsComponent,
        MsDetailsDescriptionComponent,
        MsDetailsHistoryComponent,
        MsDetailsContentComponent,
        MsDetailsRemarkpassComponent,
        MsDetailsTransmissionsComponent,
        MsDetailsOtherInfoComponent,
        BiblioSearchFormComponent,
        BiblioListComponent,
        BiblioCardComponent,
        IIPSrvImageComponent,
        CeViewerComponent,
        CeApparatusComponent,
        SearchImagesFiltersComponent,
        SearchImagesListComponent,
        SearchEditionFormComponent,
        SearchEditionResultsComponent,
        ContentUpdateInfoComponent,
        PageContentsComponent,
        FilterVocByParentPipe,
        GetMsTitlePipe,
        GetMsDatePipe,
        ImageGetNamePipe,
        ImageGetFolderPipe,
        VocTermByIdPipe,
        InArrayPipe,
        RemoveBracketsContentPipe,
        FilterRespsByTypePipe,
        StripHtmlPipe,
        SafePipe,
        SearchSectionLabelPipe,
        GetCeStructureTitlePipe
    ],
    imports: [
        BrowserModule,
        // NgbModule.forRoot(),
        AppRoutingModule,
        HttpClientModule,
        NgxPaginationModule,
        FormsModule,
        OwlModule,
        TreeModule,
        Ng2GoogleChartsModule,
        NgSelectModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatRadioModule,
        MatPaginatorModule,
        MatSelectModule,
        BrowserAnimationsModule,
        StorageServiceModule
    ],
    providers: [
        {provide: LocationStrategy, useClass: HashLocationStrategy},
        AppContentsService,
        CeReferenceService,
        CeTooltipService,
        VocsService,
        ManuscriptsService,
        ImageGetNamePipe, // needed by ManuscriptsService, MsImageGalleryComponent
        GetMsTitlePipe, // needed by HomeTimelineComponent, MssListComponent
        RemoveBracketsContentPipe, // needed by VocsService
        CriticalEditionService, // needed by NavbarComponent, SectionCriticalEditionComponent
        SearchEditionService, // needed by SearchEditionFormComponent, SearchEditionResultsComponent
        AppStorageService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts